<template>
  <div>
    <template v-for="(tab, tabIndex) in tabs">
      <button v-if="tab"
              type="button"
              :key="tabIndex"
              :class="[buttonClass, {
                _active: current === tabIndex,
                _new: false
              }]"
              @click="toggle(tabIndex)"
      >
        <span>{{ tab.name }}</span>
      </button>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'AccountTabsNavs',

    props: {
      tabs: {
        type: Array,
        default: () => []
      },
      current: {
        type: Number,
        default: 0
      },
      buttonClass: {
        type: String,
        default: 'account-tabs__nav-btn'
      }
    },

    methods: {
      toggle(index) {
        if (this.current === index) return;
        this.$emit('change', index);
      }
    }
  };
</script>
